// TODO: Remove price scheme in a separate ticket and update Coupon privacy to remove this

export interface PriceScheme {
    price: number;
    constraints: Array<PriceTypeConstraint | PrivacyConstraint>;
}

export enum ConstraintObject {
    PRICE_TYPE = "price_type_constraint",
    PRIVACY = "privacy_constraint",
}

export interface PriceTypeConstraint {
    object: ConstraintObject.PRICE_TYPE;
    priceType: PriceType;
}

export interface PrivacyConstraint {
    object: ConstraintObject.PRIVACY;
    privacy: Privacy;
}

export enum PriceType {
    PERSON = "person",
    OUTING = "outing",
}

export enum Privacy {
    PUBLIC = "public",
    PRIVATE = "private",
}
